import {
  createContext,
  useContext,
  type ReactNode,
} from 'react';

type ReservationPortalContextValue = {
  isPortal: boolean;
};

const ReservationPortalContext =
  createContext<ReservationPortalContextValue | null>(null);

function ReservationPortalProvider({
  children,
  isPortal,
}: {
  children: ReactNode;
  isPortal: boolean;
}) {
  return (
    <ReservationPortalContext.Provider value={{ isPortal }}>
      {children}
    </ReservationPortalContext.Provider>
  );
}

function useReservationPortal(): boolean {
  const context = useContext(ReservationPortalContext);
  if (!context) {
    throw new Error(
      'useReservationPortal must be used within ReservationPortalProvider',
    );
  }
  return context.isPortal;
}

export { ReservationPortalProvider, useReservationPortal };
